import { ApolloError } from "@apollo/client";

import { CardType, Currency, PaymentError } from "@/autoGeneratedGlobalTypes";

/**
 * Возвращает значок валюты
 * @param currency Валюта
 * @returns Значок валюты
 */
export const currencyToString = (currency: Currency): string => {
  switch (currency) {
    case Currency.EUR:
      return "€";
    case Currency.USD:
      return "$";
    case Currency.RUB:
      return "₽";
    default:
      return "$";
  }
};

/**
 * Возвращает причину отказа платежа для показа клиенту.
 * Пустая строка означает, что причины нет: NoError приходит при успешной оплате,
 * а незнакомый код лучше не показывать вовсе, чем печатать сырое имя из enum.
 * @param error Код ошибки платежа
 * @returns Строка с причиной отказа
 */
export const paymentErrorToString = (error: PaymentError | null): string => {
  switch (error) {
    case PaymentError.InsufficientFundsOnBalance:
      return "Недостаточно средств на карте";
    case PaymentError.IncorrectPAN:
      return "Карта не принята банком";
    case PaymentError.IncorrectPINOrCVV:
      return "Неверные данные карты";
    case PaymentError.DeclinedBy3DSCheck:
      return "Банк не подтвердил операцию";
    case PaymentError.CommonError:
      return "Произошла ошибка";
    default:
      return "";
  }
};

/**
 * Возвращает строку с типом карты для отображения
 * @param cardType Валюта
 * @returns Строка с типом карты для отображения
 */
export const cardTypeToString = (cardType: string): string => {
  // todo: cardType should be enum
  switch (cardType) {
    case CardType.Mastercard:
      return "MasterCard";
    case CardType.VISA:
      return "Visa";
    // case "apple":
    //   return "Apple Pay";
    case CardType.Mir:
      return "Мир";
    default:
      return "";
  }
};

// todo: convert number[] to enum array when it's ready on backend
export const parseErrors = (error: ApolloError | undefined): number[] => {
  const errorObj = JSON.parse(JSON.stringify(error));
  return errorObj.graphQLErrors.map((errorItem: { extensions: { code: any } }) =>
    parseInt(errorItem.extensions.code, 10));
};
